<template>

    <div>
        <slot name="clickable" :toggleModal="toggleModal">
            <button type="button" :class="button_classes" v-html="button_text" @click.prevent="toggleModal"></button>
        </slot>

        <transition
            enter-active-class="ease-out duration-300"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="ease-in duration-200"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div :id="id" class="fixed z-50 inset-0 overflow-y-auto" :aria-labelledby="id" role="dialog" aria-modal="true" aria-hidden="false" v-show="display">
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" @click="cancel"></div>

                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                    <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                        <div>
                            <slot></slot>
                        </div>
                        <div class="flex mt-5 sm:mt-6 w-full">
                            <button type="button" class="flex-1 btn-outline justify-center mx-1" v-show="show_close" @click.prevent="cancel">
                                {{ close_text }}
                            </button>
                            <button type="button" class="flex-1 btn justify-center mx-1" v-show="show_confirm" @click.prevent="confirm">
                                {{ confirm_text }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

    </div>

</template>

<script>
export default {
    name: "ConfirmationModal",
    props: {
        id: {
            required: false,
            default: 'confirmation-modal'
        },
        button_classes: {
            type: String,
            required: false,
            default: 'btn justify-center'
        },
        button_text: {
            type: String,
            required: false,
            default: 'Button'
        },
        show_close: {
            type: Boolean,
            required: false,
            default: true
        },
        show_confirm: {
            type: Boolean,
            required: false,
            default: true
        },
        close_text: {
            type: String,
            required: false,
            default: 'Close'
        },
        confirm_text: {
            type: String,
            required: false,
            default: 'Confirm'
        },
    },
    data() {
        return {
            display: false
        }
    },
    methods: {
        toggleModal() {
            this.display = ! this.display;

            if (this.display) {
                this.$emit('openModal')
            } else {
                this.$emit('closeModal')
            }
        },
        confirm() {
            let vm = this;

            new Promise(resolve => {
                vm.toggleModal();

                vm.$emit('confirmModal');

                resolve(true);
            });
        },
        cancel() {
            let vm = this;

            new Promise(resolve => {
                vm.toggleModal();

                vm.$emit('cancelModal');

                resolve(true);
            });
        }
    }
}
</script>


